import { render, staticRenderFns } from "./TableFieldMapping.vue?vue&type=template&id=6dbfe6e0"
import script from "./TableFieldMapping.vue?vue&type=script&lang=js"
export * from "./TableFieldMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports